import { Component, Input, OnInit } from '@angular/core';


/**
 * Component to group pivotal and major icons
 */
@Component({
    selector: 'rms-pivotal-major',
    templateUrl: './pivotal-major.component.html',
    styleUrls: ['./pivotal-major.component.scss'],
    standalone: false
})
export class PivotalMajorComponent implements OnInit {
  @Input() major: boolean;

  constructor() { }

  ngOnInit() {
  }

}
